import type { Transaction } from "@boo/shared";

// What a transaction costs the user: their share plus any unpaid member
// shares, minus paybacks linked directly to it. Mirrors the API's net-cost rule.
export function effectiveAmount(t: Transaction): number {
  const base =
    t.splitType != null && t.myShare != null
      ? t.myShare +
        (t.splitMembers ?? [])
          .filter((m) => !m.isPaid)
          .reduce((s, m) => s + m.amount, 0)
      : t.amount;
  return Math.max(0, base - (t.reimbursedAmount ?? 0));
}
